import { useLogin } from '@pankod/refine-core'
import { AntdLayout, notification, Typography } from '@pankod/refine-antd'
import { GoogleLogin, CredentialResponse } from '@react-oauth/google'
import Head from 'next/head'
import Image from 'next/image'

import { BASE_PATH } from 'src/constant'
const { Title } = Typography
const Login: React.FC = () => {
  const { mutate: login } = useLogin<CredentialResponse>()

  return (
    <AntdLayout
      style={{
        background: `radial-gradient(50% 50% at 50% 50%, #bbb 0%, #333 100%)`,
        backgroundSize: 'cover',
      }}
    >
      <Head>
        <title>LMS Admin | Login</title>
      </Head>
      <div style={{ height: '100vh', display: 'flex' }}>
        <div
          style={{ margin: 'auto', textAlign: 'center' }}
          className="bg-white p-5 rounded-2xl shadow-lg"
        >
          <div
            style={{
              marginBottom: '20px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
            className="items-center gap-4"
          >
            <img src={`${BASE_PATH}/logo.svg`} alt="logo" className="h-12" />
            <Title
              level={2}
              style={{
                margin: '0',
              }}
              className="!text-gray-700"
            >
              LMS Admin
            </Title>
          </div>
          <div className="flex items-center justify-center">
            <GoogleLogin
              shape="pill"
              onSuccess={(credentialResponse) => {
                login(credentialResponse)
              }}
              onError={() => {
                notification.open({
                  description: 'Silakan ulangi kembali',
                  message: 'Gagal login',
                  type: 'error',
                })
              }}
              theme="filled_blue"
            />
          </div>
          <Image
            alt="BSrE Logo"
            src={'/img/BSrE-logo.png'}
            width={90}
            height={30}
            className="mt-[20px]"
            style={{ objectFit: 'contain' }}
          />
        </div>
      </div>
    </AntdLayout>
  )
}

export default Login
